import { render } from "./FormFieldFileBox.vue?vue&type=template&id=408a6177"
import script from "./FormFieldFileBox.vue?vue&type=script&lang=js"
export * from "./FormFieldFileBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__